/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idnes_Use_TestInputs */

const cs_idnes_use_test = /** @type {(inputs: Idnes_Use_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít test.reality.idnes.cz`)
};

const en_idnes_use_test = /** @type {(inputs: Idnes_Use_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use test.reality.idnes.cz`)
};

/**
* | output |
* | --- |
* | "Use test.reality.idnes.cz" |
*
* @param {Idnes_Use_TestInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const idnes_use_test = /** @type {((inputs?: Idnes_Use_TestInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idnes_Use_TestInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_idnes_use_test(inputs)
	return cs_idnes_use_test(inputs)
});